import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { string as yupString } from "yup";
import TextInputField from "./text-input-field";
import sharedMessages from "../../../../shared-messages";

const forbiddenEmails = ["changeme@ebsco.com", "updateneeded@ebsco.com"];

const EmailField = ({
  id,
  className,
  name,
  description,
  isRequired = true
}) => {
  const { formatMessage } = useIntl();

  let labelMessage = sharedMessages.emailAddressOptional;
  let emailValidationSchema = yupString()
    .email(formatMessage(sharedMessages.invalidEmailAddress))
    .test(
      "forbidden-email",
      formatMessage(sharedMessages.preexistingEmailAddress),
      value => (value ? !forbiddenEmails.includes(value.toLowerCase()) : true)
    );

  if (isRequired) {
    labelMessage = sharedMessages.emailAddress;
    emailValidationSchema = emailValidationSchema.required(
      formatMessage(sharedMessages.requireEmailAddress)
    );
  }

  const textInputFieldProps = {
    id,
    className,
    name,
    label: formatMessage(labelMessage),
    validationSchema: emailValidationSchema,
    "aria-required": isRequired.toString(),
    inputMode: "email",
    description,
    autoComplete: "email"
  };

  return <TextInputField {...textInputFieldProps} />;
};

EmailField.defaultProps = { id: "email", className: "email", name: "email" };

EmailField.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  isRequired: PropTypes.bool
};

export default EmailField;
